export default {
  directMessages(state) {
    return state.directMessages
  },
}
